/* assets/block-australia.js
   V15: Bloqueo Seguro (Anti-Loop Fix)
   - Desconecta el observador antes de aplicar cambios para evitar bucles infinitos.
   - Mantiene el texto "Out of stock" si está bloqueado.
*/

document.addEventListener('DOMContentLoaded', function() {
  let product_name = document.querySelectorAll('h1')[0].innerHTML;
  console.log('🛡️ Block Australia JS Cargado (V15 Safe Mode).');

  if (!window.productVariantRules) return;

  // Referencias globales
  let buttonObserver = null;
  const targetNode = document.body; // Observamos cambios generales con cuidado
  
  // Estado actual
  let currentBlockState = {
    shouldBlock: false,
    reason: ''
  };

  // 1. Lógica principal de decisión
  function calculateBlockState() {
    const rules = window.productVariantRules;
    const country = rules.country;
    
    // Obtener ID variante
    const urlParams = new URLSearchParams(window.location.search);
    let currentVariantId = urlParams.get('variant');

    if (!currentVariantId) {
       const inputId = document.querySelector('input[name="id"]');
       if(inputId) currentVariantId = inputId.value;
       else {
         const variantKeys = Object.keys(rules.variants);
         if(variantKeys.length > 0) currentVariantId = variantKeys[0];
       }
    }

    const variantRule = rules.variants[currentVariantId];
    if (!variantRule) return; 

    // Reset estado
    currentBlockState.shouldBlock = false;
    currentBlockState.reason = '';

    // Reglas de Bloqueo
    if (variantRule.native_available === false) {
       currentBlockState.shouldBlock = true;
       currentBlockState.reason = 'native'; // "Out of stock" nativo
    } 
    else if (country === 'AU' && variantRule.au_meta !== 'true') {
       currentBlockState.shouldBlock = true;
       currentBlockState.reason = 'region'; // Bloqueo por región
    }
    else if (country === 'US' && variantRule.us_meta === 'false') {
       currentBlockState.shouldBlock = true;
       currentBlockState.reason = 'region';
    }

    applyChangesToDOM();
  }

  // 2. Aplicar cambios al DOM (CON SEGURIDAD)
  function applyChangesToDOM() {
    // A. APAGAR EL VIGILANTE (Vital para evitar bucle infinito)
    if (buttonObserver) buttonObserver.disconnect();

    // B. Realizar los cambios
    const addBtns = document.querySelectorAll('button[name="add"], .add-to-cart-button, .product-form__submit');
    
    addBtns.forEach(btn => {
      const btnTextSpan = btn.querySelector('span') || btn;
      let targetText = ( product_name == "Bonnell 775 MX" ) ? 'Available at Dealers' : 'Out of stock'; 

      if (currentBlockState.shouldBlock) {
          // Guardar texto original si no es "Out of stock"
          const currentText = btnTextSpan.innerText.trim();
          if (!btn.getAttribute('data-original-text') && currentText !== targetText && !currentText.includes('stock')) {
               btn.setAttribute('data-original-text', currentText);
          }

          // APLICAR BLOQUEO
          // Solo tocamos el DOM si es estrictamente necesario (ahorra recursos)
          if (!btn.disabled || currentText !== targetText) {
              btn.disabled = true;
              btn.classList.add('disabled');
              btn.style.opacity = '0.5';
              btn.style.cursor = 'not-allowed';
              btnTextSpan.innerText = targetText;
          }
      } else {
          // DESBLOQUEAR
          if (btn.disabled || btnTextSpan.innerText === targetText) {
              btn.disabled = false;
              btn.classList.remove('disabled');
              btn.style.opacity = '1';
              btn.style.cursor = 'pointer';
              
              const originalText = btn.getAttribute('data-original-text');
              // Restaurar texto original (o Add to cart por defecto)
              if (originalText) {
                  btnTextSpan.innerText = originalText;
              } else {
                  btnTextSpan.innerText = 'Add to cart';
              }
          }
      }
    });

    // C. RE-ENCENDER EL VIGILANTE
    setupObserver();
  }

  // 3. Configuración del Vigilante
  function setupObserver() {
    // Si ya existe, desconectarlo primero por seguridad
    if (buttonObserver) buttonObserver.disconnect();

    const productForm = document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
    
    if (productForm) {
        buttonObserver = new MutationObserver((mutations) => {
            // Verificamos si la mutación NO fue causada por nosotros
            // (Aunque el disconnect ayuda, esto es doble seguridad)
            let externalChange = false;
            for (const mutation of mutations) {
                // Si el cambio fue en un atributo que nosotros controlamos, intentamos ignorar
                // Pero como desconectamos, esto atrapará cambios del TEMA.
                externalChange = true; 
            }

            if (externalChange) {
                // Volvemos a calcular y aplicar (esto volverá a desconectar el observer)
                calculateBlockState();
            }
        });

        // Observamos cambios en el formulario y botones hijos
        buttonObserver.observe(productForm, { 
            childList: true, 
            subtree: true, 
            attributes: true, 
            attributeFilter: ['disabled', 'class'] // Solo miramos lo importante
        });
    }
  }

  // --- INICIALIZACIÓN ---
  
  // 1. Ejecutar inmediatamente
  calculateBlockState();

  // 2. Escuchar cambios de URL (Variantes)
  let lastUrl = location.href; 
  setInterval(() => {
      if (location.href !== lastUrl) {
          lastUrl = location.href;
          calculateBlockState();
      }
  }, 500); // Usamos polling suave en lugar de observer en body para evitar conflictos

  // 3. Escuchar clicks en opciones (Tallas/Colores)
  const variantInputs = document.querySelectorAll('fieldset input, variant-radios input, variant-selects select');
  variantInputs.forEach(input => {
      input.addEventListener('change', () => {
           setTimeout(calculateBlockState, 100);
      });
  });

});